export default (
	endpoint = 'resources',
	count = -1,
) => ({
	items: [],
	selected_type: '*',
	selected_topic: '*',
	async init() {
		this.$watch('items_for_type', (value) => this.dispatchAvailableTopics(value) );
		let url = `/wp-json/epic/v2/${endpoint}?count=${count}`;
		let resp = await fetch(url);
		this.items = await resp.json();
	},
	dispatchAvailableTopics(value) {
		const topics = value.map( item => item.topics ).flat();
		this.$dispatch('availabletopics', [ ...new Set(topics) ] );
	},
	filter() {
		if ( this.$event.detail.field === 'type' ) {
			this.selected_type = this.$event.detail.value;
		} else if ( this.$event.detail.field === 'topic' ) {
			this.selected_topic = this.$event.detail.value;
		}

	},
	get filtered_items() {
		if ( this.items ) {
			if (
				this.selected_type === '*'
				&& this.selected_topic === '*'
			) {
				return this.items;
			}

			let _items = this.items;
			if ( this.selected_type !== '*' ) {
				_items = _items.filter( item => {
					return item.type === this.selected_type;
				} );
			}

			if ( this.selected_topic !== '*' ) {
				_items = _items.filter( item => {
					return item.topics.includes(this.selected_topic);
				} );
			}

			return _items;
		}

		return [];
	},
	get items_for_type() {
		if ( !this.items ) { return []; }

		if ( this.selected_type === '*' ) { return this.items; }

		return this.items.filter( item => item.type === this.selected_type );
	},
});
